const Suple = () => {
    return (
        <section className="flex flex-row items-center w-full justify-center mq450:h-auto bg-white">
        <div id="suple" className="flex flex-col max-w-[1280px] w-full justify-between px-[24px] gap-[80px] mq450:px-4  mq450:gap-[48px] h-full py-[96px] mq450:py-[32px]">
        <div id="top" className="flex flex-row mq450:flex-col gap-[64px] mq450:gap-[24px] justify-center items-end">
            <div id="left" className="flex flex-col w-full gap-[12px]">
                <div id="title" className='font-silka-semibold font-[600] text-[16px] leading-[130%] text-[#362F5B] mq450:text-[14px] uppercase'>WEGAŃSKIE ŻELKI BEZ CUKRU</div>
                <div id="subtitle" className='font-silka-semibold font-[600] text-[40px] leading-[130%] text-[#362F5B] mq450:text-[24px]'>Suplementy</div>
            </div>
            <div id="right" className="w-auto">
            <div id='text' className='text-[18px] font-silka-semibold font-[300] text-[#362F5B]'>Nasze żelki to doskonałe połączenie smaku i zdrowia.
            Wybierz suplementy, które wspierają Twoje cele zdrowotne!</div>
            </div>
        </div>
        <div id="content" className="flex flex-col gap-[24px] mq450:flex-col">
        <div id="row" className="flex flex-row gap-[24px] mq450:flex-col">
        <div id="card" className="flex flex-col w-full rounded-[16px] bg-[#939ACB]">
            <div id="top" className="flex flex-col gap-[8px] text-white p-[24px]">
            <div id="title" className="font-silka-semibold font-[600]">MoonEase™</div>
            <div id="subtitle">Redukuje skutki PMS</div>
            </div>
            <div id="bottom" className="flex justify-center items-center p-[32px]">
            <img src="/MoonEase_web.png" className="w-full object-contain"/>
            </div>
        </div>
        <div id="card" className="flex flex-col w-full rounded-[16px] bg-[#5069B0]">
            <div id="top" className="flex flex-col gap-[8px] text-white p-[24px]">
            <div id="title" className="font-silka-semibold font-[600]">NightBloom™</div>
            <div id="subtitle">Wspiera zdrowy sen</div>
            </div>
            <div id="bottom" className="flex justify-center items-center p-[32px]">
            <img src="/NightBloom_web.png" className="w-full object-contain"/>
            </div>
        </div>
        <div id="card" className="flex flex-col w-full rounded-[16px] bg-[#009AD2]">
            <div id="top" className="flex flex-col gap-[8px] text-white p-[24px]">
            <div id="title" className="font-silka-semibold font-[600]">ZenBlossom™</div>
            <div id="subtitle">Relaksuje umysł i ciało</div>
            </div>
            <div id="bottom" className="flex justify-center items-center p-[32px]">
            <img src="/ZenBlossom_web.png" className="w-full object-contain"/>
            </div>
        </div>
        </div>
        <div id="row" className="flex flex-row gap-[24px] mq450:flex-col">
        <div id="card" className="flex flex-col w-full rounded-[16px] bg-[#ED6A38]">
            <div id="top" className="flex flex-col gap-[8px] text-white p-[24px]">
            <div id="title" className="font-silka-semibold font-[600]">GlowLeaf™</div>
            <div id="subtitle">Wzmacnia włosy, skórę i paznokcie</div>
            </div>
            <div id="bottom" className="flex justify-center items-center p-[32px]">
            <img src="/GlowLeaf_web.png" className="w-full object-contain"/>
            </div>
        </div>
        <div id="card" className="flex flex-col w-full rounded-[16px] bg-[#F18700]">
            <div id="top" className="flex flex-col gap-[8px] text-white p-[24px]">
            <div id="title" className="font-silka-semibold font-[600]">BrightMind™</div>
            <div id="subtitle">Poprawia koncentracje i pracę umysłu</div>
            </div>
            <div id="bottom" className="flex justify-center items-center p-[32px]">
            <img src="/BrightMind_web.png" className="w-full object-contain"/>
            </div>
        </div>
        <div id="card" className="flex flex-col w-full rounded-[16px] bg-[#75B843]">
            <div id="top" className="flex flex-col gap-[8px] text-white p-[24px]">
            <div id="title" className="font-silka-semibold font-[600]">LeafTrim™</div>
            <div id="subtitle">Wspiera smukła sylwetkę</div>
            </div>
            <div id="bottom" className="flex justify-center items-center p-[32px]">
            <img src="/LeafTrim_web.png" className="w-full object-contain"/>
            </div>
        </div>
        </div>
        </div>


        </div>
      </section>
    );
  };
  
  export default Suple;
  